import HotelStatusIcon from 'components/HotelStatusIcon'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import ArrowDown from '../../../../components/ReusableComponents/Icons/ArrowDown'
import ArrowUp from '../../../../components/ReusableComponents/Icons/ArrowUp'
import DotIcon from '../../../../components/ReusableComponents/Icons/Dot'
import { Cell, Row, Spacer } from '../../../../components/ReusableComponents/Table'
import HotelIdCell from '../../Common/HotelIdCell'
import HotelNameCell from '../../Common/HotelNameCell/index'
import useNote from '../../Common/useNote'
import CheckCell from '../CheckCell'
import styles from './Row.module.scss'
import CustomTooltip from './Tooltip'

const NumberStatCell = ({ value, ...props }) => {
  const [isHovering, setHovering] = useState()

  return (
    <Cell className={styles.numberStatCell} {...props}>
      <div onMouseOver={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
        {value?.isIncreasing === true && <ArrowUp />}
        {value?.isIncreasing === false && <ArrowDown />}
        {value?.isIncreasing == null && <DotIcon />}

        {value?.periodCurrent}
        <CustomTooltip {...value} isVisible={isHovering} />
      </div>
    </Cell>
  )
}

const GoToAnalyticsButton = ({ subsidiaryId }) => {
  return (
    <Link to={`/s/${subsidiaryId}/analytics`}>
      <button>Go to Reports overview →</button>
    </Link>
  )
}

const AutoInviteHealthRow = ({
  showTelcoDetails,
  brand,
  displayId,
  invited,
  clicks,
  textInbound,
  textOutbound,
  segmentInbound,
  segmentOutbound,
  optOut,
  inviteFailedSpam,
  inviteFailedOther,
  bookings,
  conversions,
  shortName,
  marketingCampaigns,
  subsidiaryId,
  index,
  subsidiaryStatus,
  rowStatus,
  statusExplanation
}) => {
  const {
    note,
    setNote,
    isLoading: isLoadingNote,
    isSaving,
    error: noteError
  } = useNote(subsidiaryId, 'healthCheck-autoinvite')

  return (
    <div
      className={`${styles.rowHolder} ${rowStatus ? styles[rowStatus] : ''}`}
      title={statusExplanation}
    >
      <div className={styles.index}>{index}</div>
      <div className={styles.statusIcon}>
        <HotelStatusIcon status={subsidiaryStatus} />
      </div>
      {showTelcoDetails ? (
        <Row>
          <HotelIdCell displayId={displayId} />
          <HotelNameCell
            brand={brand}
            name={shortName}
            navigationControl={<GoToAnalyticsButton subsidiaryId={subsidiaryId} />}
          />
          <NumberStatCell value={clicks} />
          <NumberStatCell value={invited} />
          <NumberStatCell value={bookings} />
          <NumberStatCell value={conversions} />
          <NumberStatCell value={textInbound} />
          <NumberStatCell value={textOutbound} />
          <NumberStatCell value={optOut} />
          <NumberStatCell value={segmentInbound} />
          <NumberStatCell value={segmentOutbound} />
          <NumberStatCell value={inviteFailedSpam} />
          <NumberStatCell value={inviteFailedOther} />
          <Cell className={styles.noteCell}>
            <input
              type="text"
              value={note || ''}
              onChange={e => setNote(e.target.value)}
              placeholder=" "
              disabled={isLoadingNote}
            />
            {isSaving && <span className={styles.savingIndicator}>Saving...</span>}
            {noteError && <div className={styles.noteError}>{noteError}</div>}
          </Cell>
        </Row>
      ) : (
        <Row>
          <HotelIdCell displayId={displayId} />
          <HotelNameCell
            brand={brand}
            name={shortName}
            navigationControl={<GoToAnalyticsButton subsidiaryId={subsidiaryId} />}
          />
          <NumberStatCell value={clicks} />
          <NumberStatCell value={invited} />
          <NumberStatCell value={bookings} />
          <NumberStatCell value={conversions} />
          <Spacer />
          <CheckCell
            campaign={marketingCampaigns?.find(
              campaign => campaign.category === 'Lost3Months'
            )}
          />
          <CheckCell
            campaign={marketingCampaigns?.find(
              campaign => campaign.category === 'Lost6Months'
            )}
          />
          <CheckCell
            campaign={marketingCampaigns?.find(
              campaign => campaign.category === 'Lost9Months'
            )}
          />
          <CheckCell
            campaign={marketingCampaigns?.find(
              campaign => campaign.category === 'Lost12Months'
            )}
          />
          <CheckCell
            campaign={marketingCampaigns?.find(
              campaign => campaign.category === 'Lost15Months'
            )}
          />
          <CheckCell
            campaign={marketingCampaigns?.find(
              campaign => campaign.category === 'Lost15MonthsPlus'
            )}
          />
          <CheckCell
            campaign={marketingCampaigns?.find(
              campaign => campaign.category === 'AfterLastVisit'
            )}
          />
          <Cell className={styles.noteCell}>
            <input
              type="text"
              value={note || ''}
              onChange={e => setNote(e.target.value)}
              placeholder=" "
              disabled={isLoadingNote}
            />
            {isSaving && <span className={styles.savingIndicator}>Saving...</span>}
            {noteError && <div className={styles.noteError}>{noteError}</div>}
          </Cell>
        </Row>
      )}
    </div>
  )
}

export default AutoInviteHealthRow
